import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Typography,
} from "@mui/material";
import SkeletonImage from "../../../../components/ui/SkeletonImage";
import { FILE_PATH_URI } from "../../../../utils/helper";
import { Fragment } from "react";
import moment from "moment";

function TrustSafety({ specialist }) {
  return (
    <Fragment>
      <Typography sx={{ fontSize: "24px", fontWeight: "600" }}>
        Trust & safety
      </Typography>
      <TableContainer className="specialistTable">
        <Table stickyHeader>
          <TableBody>
            <TableRow>
              <TableCell component="th">Full name</TableCell>
              <TableCell>{specialist?.specialist?.fullName}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{ whiteSpace: "normal !important" }}
                component="th"
              >
                Date of Birth
              </TableCell>
              <TableCell>
                {moment(specialist?.background?.dob).format("DD-MMM-YYYY")}
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{ whiteSpace: "normal !important" }}
                component="th"
              >
                Personal Identification
              </TableCell>
              <TableCell>
                <Box
                  sx={{
                    borderRadius: 2,
                    overflow: "hidden",
                    aspectRatio: "1/1",
                    position: "relative",
                    display: "inline-block",
                    width: { xs: "initial", md: "250px" },
                  }}
                >
                  <SkeletonImage
                    src={
                      FILE_PATH_URI +
                      specialist?.background?.personalIdentification?.[0]?.path
                    }
                  />
                </Box>
              </TableCell>
            </TableRow>
            <TableRow>
              <TableCell
                sx={{ whiteSpace: "normal !important" }}
                component="th"
              >
                Professional Identification
              </TableCell>
              <TableCell>
                <Box
                  sx={{
                    borderRadius: 2,
                    overflow: "hidden",
                    aspectRatio: "1/1",
                    position: "relative",
                    display: "inline-block",
                    width: { xs: "initial", md: "250px" },
                  }}
                >
                  <SkeletonImage
                    src={
                      FILE_PATH_URI +
                      specialist?.background?.professionalIdentification?.[0]
                        ?.path
                    }
                  />
                </Box>
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Fragment>
  );
}

export default TrustSafety;
